import { envType } from '@atlassiansox/analytics-web-client';
import { initializeAnalyticsClient } from '@databases/analytics';
import { type BridgeData } from '@databases/database-state/state/bridge-data';
import { perf } from '@databases/logs/performance';

export const initializeAnalytics = ({
  cloudId,
  spaceId,
  userId,
}: Pick<BridgeData, 'cloudId' | 'spaceId' | 'userId'>) => {
  perf.timeLog('app-initialization', 'analytics');

  initializeAnalyticsClient(
    process.env.ENVTYPE === envType.LOCAL || !process.env.ENVTYPE ? undefined : cloudId,
    spaceId,
    userId,
    process.env.ENVTYPE ?? envType.LOCAL,
    process.env.SENTRY_RELEASE ?? 'development'
  );
};
